type Environment = 'prod' | 'staging' | 'dev' | 'local';

interface Config {
  apiBaseUrl: string;
  agentApiBaseUrl: string;
  agentIframeBaseUrl: string;
  micrositesOrigin: string;
  azureClientId: string;
  azureTenantId: string;
  sentryDSN: string;
  environment: Environment;
  extensionGTMId: string;
  extensionSecretToken: string;
  extensionSpendbrainRedirectUrl: string;
  isExtension: boolean;
  mixpanelProjectToken: string;
  spendbrainVersion?: string;
  appStoreAppUrl: string;
  googlePlayAppUrl: string;
  storybookEnabled: boolean;
}

const config: Config = {
  apiBaseUrl:
    import.meta.env.VITE_MICROSITES_BASE_API_URL ||
    import.meta.env.VITE_SIDECAR_BASE_API_URL ||
    import.meta.env.VITE_EXTENSION_BASE_API_URL,
  agentApiBaseUrl: import.meta.env.VITE_MICROSITES_AGENT_API_BASE_URL,
  agentIframeBaseUrl: import.meta.env.VITE_AGENT_IFRAME_BASE_URL,
  micrositesOrigin: import.meta.env.VITE_MICROSITES_ORIGIN,
  isExtension: !!import.meta.env.MANIFEST_VERSION,
  azureClientId:
    import.meta.env.VITE_MICROSITES_CLIENT_ID ||
    import.meta.env.VITE_SIDECAR_CLIENT_ID ||
    import.meta.env.VITE_EXTENSION_CLIENT_ID,
  azureTenantId:
    import.meta.env.VITE_MICROSITES_TENANT_ID ||
    import.meta.env.VITE_SIDECAR_TENANT_ID ||
    import.meta.env.VITE_EXTENSION_TENANT_ID,
  sentryDSN:
    import.meta.env.VITE_MICROSITES_SENTRY_DSN ||
    import.meta.env.VITE_EXTENSION_SENTRY_DSN ||
    import.meta.env.VITE_SIDECAR_SENTRY_DSN,
  environment: (import.meta.env.VITE_MICROSITES_ENVIRONMENT ||
    import.meta.env.VITE_SIDECAR_ENVIRONMENT ||
    import.meta.env.VITE_EXTENSION_ENVIRONMENT) as Environment,

  extensionGTMId: import.meta.env.VITE_EXTENSION_GTM_ID,
  extensionSecretToken: import.meta.env.VITE_EXTENSION_SECRET_TOKEN,
  mixpanelProjectToken: import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN,
  extensionSpendbrainRedirectUrl: import.meta.env
    .VITE_EXTENSION_SPENDBRAIN_REDIRECT_URL,
  spendbrainVersion: import.meta.env.VITE_SPENDBRAIN_VERSION,
  appStoreAppUrl: import.meta.env.VITE_MICROSITES_APP_STORE_URL,
  googlePlayAppUrl: import.meta.env.VITE_MICROSITES_GOOGLE_PLAY_URL,
  storybookEnabled: !!import.meta.env.VITE_STORYBOOK_ENABLED,
};

export default config;
